<div class="visualizations">
  <div class="visualizations__loading" *ngIf="ui.isLoading; else loaded">
    <mat-spinner></mat-spinner>
  </div>
  <ng-template #loaded>
    <ng-container *ngIf="chartData$ | async as chartData; else noVisualizations">
      <chart
        *ngFor="let chart of chartData"
        [chartDef]="chart"
        [hideEdit]="!(NewPermission.REPORTS_BUILDER_EDIT | hasPermission)"
        [hideRemove]="!(NewPermission.REPORTS_BUILDER_EDIT | hasPermission)"
        [hideTitle]="true"
        [hideRefresh]="false"
        [fillMode]="true"
        [fields]="fields"
        [isTimeSeries]="isTimeSeries"
        (editChart)="edit()"
        (removeChart)="removeChart.emit(chart)"
        (dataPointSelection)="onDataPointSelection($event)"
        (refreshChart)="refreshChart.emit()"
      ></chart>
      <ng-container *ngIf="!chartData?.length">
        <ng-container *ngTemplateOutlet="noVisualizations"></ng-container>
      </ng-container>
    </ng-container>
    <ng-template #noVisualizations>
      <div class="visualizations__empty" *ngIf="!ui.isLoading">
        <mat-icon class="visualizations__empty__report-icon" svgIcon="heroicons_outline:document-report"></mat-icon>
        <div class="visualizations__empty__prompt">
          <h4>You don't have any visualization.</h4>
          <p>
            <mat-icon>lightbulb_outline</mat-icon>
            Start adding visualizations by clicking&nbsp;<a (click)="create()">here</a>.
          </p>
        </div>
      </div>
    </ng-template>
  </ng-template>
</div>
